export default "__VITE_ASSET__BtZbxb5R__"